import 'css-chunksrc/client/pages/projectPage/timeSheetPage/navigation/week/dateTimeInput/styles.scss';export default {
  "root": "_root_1ah1q_1",
  "inputBox": "_inputBox_1ah1q_5",
  "arrow": "_arrow_1ah1q_14",
  "leftArrowWrapper": "_leftArrowWrapper_1ah1q_22",
  "rightArrowWrapper": "_rightArrowWrapper_1ah1q_35",
  "calendarButton": "_calendarButton_1ah1q_48",
  "leftArrow": "_leftArrow_1ah1q_22",
  "rightArrow": "_rightArrow_1ah1q_35",
  "title": "_title_1ah1q_74",
  "calendarIcon": "_calendarIcon_1ah1q_85",
  "dateTimeInput": "_dateTimeInput_1ah1q_92"
};